<template>
  <div id="ecommerce_product_add">
    <div class="modal" id="modal_add_product" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" style="display:inline-block" v-if="currentView == 'product'">
              Add Product
            </h5>
            <h5 class="modal-title" style="display:inline-block" v-else>Add Stock</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <vue-simple-svg
                :filepath="'/static/img/assets/_global/Close.svg'"
                width="50px"
                height="auto"
                class="icon"
              />
            </button>
          </div>
          <template v-if="currentView == 'product'">
            <div class="modal-body">
              <div class="row">
                <div class="col-xs-12">
                  <div class="form-group" :class="{ 'has-error': errors.has('categoryInput') }">
                    <label for="categoryInput">Category *</label>
                    <select-category
                      :pageid="pageid"
                      v-model="category"
                      data-vv-name="categoryInput"
                      data-vv-as="Category"
                      :selected="currentCategory"
                      @onChangeCategory="onChangeCategory"
                      v-validate="'required'"
                    ></select-category>
                    <p class="text-error" v-show="errors.has('categoryInput')">
                      {{ errors.first('categoryInput') }}
                    </p>
                  </div>

                  <!--<div class="form-group">
									<label for="subCategoryInput">Sub Category</label>
									<select name="subCategory" class="form-control"  v-model="product.subcategoryid">
										<option value="0">Select Sub-Category</option>
										<template v-if="currentCategory">
											<option :value="subcategory.id" v-for="(subcategory,index) in currentCategory.subcategories" :key="'subcategory_'+index">{{ subcategory.name }}</option>
										</template>
									</select>
								</div>-->
                </div>
                <div class="col-xs-12 ">
                  <div
                    class="pb-3"
                    style="padding-top:15px;"
                    :class="{ 'has-error': errors.has('uploadMultipleFile') }"
                  >
                    <!-- <uploadfile v-model="product.photourl"></uploadfile> -->
                    <upload-multiple-file
                      v-model="productImages"
                      :max="3"
                      data-vv-name="uploadMultipleFile"
                      data-vv-as="Preview Image"
                      v-validate="'required'"
                    ></upload-multiple-file>

                    <p class="text-error" v-show="errors.has('uploadMultipleFile')">
                      {{ errors.first('uploadMultipleFile') }}
                    </p>
                  </div>
                </div>
                <div>
                  <!-- <div class="form-group" :class="{'has-error': errors.has('priceInput')}">
									<label for="priceInput">Price *</label>
									<div class="form-inline">
										<div style="padding: 6px 12px;border-radius: 50%;display: inline-block;background: #eee;margin-right: 5px;">{{currencySign}}</div>
										<input type="text" class="form-control" id="priceInput" name="priceInput" data-vv-as="Price" aria-describedby="price" ref="price" placeholder="Price" v-model="product.price" v-validate="'required|decimal|min_value:0'" style="max-width: 150px;display: inline;"> &nbsp;
										<p class="text-error" v-show="errors.has('priceInput')">{{ errors.first('priceInput') }}</p>
									</div>
								</div>

								<div class="form-group" :class="{'has-error': errors.has('discountPriceInput')}">
									<label for="dicountPriceInput">Discount *</label>
									<div class="form-inline">
										<div style="padding: 6px 12px;border-radius: 50%;display: inline-block;background: #eee;margin-right: 5px;">{{currencySign}}</div>
										<input type="text" class="form-control" id="discountPriceInput" name="discountPriceInput" data-vv-as="Discount" aria-describedby="Discount" placeholder="Discount" v-model="product.discountprice" v-validate="'required|decimal|min_value:0|isLessThanOrEqual:price'" style="max-width: 150px;display: inline;"> &nbsp;
										<p class="text-error" v-show="errors.has('discountPriceInput')">{{ errors.first('discountPriceInput') }}</p>
									</div>
								</div> -->

                  <!-- <div class="form-group">
									<label for="discountPercentage">Discount Percentage</label>
									<div class="form-inline">
										 <span v-if="product.discountprice && parseFloat(product.discountprice) > 0 && parseFloat(product.price) >= parseFloat(product.discountprice)" style="padding:5px 10px;background:red;color:white;">{{( (product.price - product.discountprice) / product.price ) * 100 | numberFormat }} %</span> <span v-else style="padding:5px 10px;background:#eee;color:white;">0 %</span>
									</div>
								</div> -->
                </div>

                <div class="col-xs-12">
                  <div class="form-group" :class="{ 'has-error': errors.has('nameInput') }">
                    <label for="nameInput">Name *</label>
                    <input
                      type="text"
                      class="form-control"
                      ref="name"
                      id="nameInput"
                      name="nameInput"
                      data-vv-as="Name"
                      aria-describedby="name"
                      placeholder="Name"
                      v-model="product.name"
                      v-validate="'required'"
                    />
                    <p class="text-error" v-show="errors.has('nameInput')">
                      {{ errors.first('nameInput') }}
                    </p>
                  </div>

                  <div class="form-group" :class="{ 'has-error': errors.has('descriptionInput') }">
                    <label for="descriptionInput">Place Detail *</label>
                    <textarea
                      type="text"
                      class="form-control"
                      id="descriptionInput"
                      name="descriptionInput"
                      style="resize:vertical"
                      data-vv-as="Description"
                      aria-describedby="description"
                      placeholder="Description"
                      row="3"
                      v-model="product.description"
                      v-validate="'required'"
                    ></textarea>
                    <p class="text-error" v-show="errors.has('descriptionInput')">
                      {{ errors.first('descriptionInput') }}
                    </p>
                  </div>

                  <div class="form-group" :class="{ 'has-error': errors.has('tags') }">
                    <label for="keywordInput">Keywords *</label>
                    <vue-tags-input
                      v-model="tag"
                      :tags="tags"
                      @tags-changed="newTags => (tags = newTags)"
                      @before-adding-tag="checkTag"
                      name="keywordInput"
                      data-vv-as="Keyword"
                    />
                    <input
                      type="hidden"
                      v-model="tags"
                      name="tags"
                      data-vv-as="Keyword"
                      v-validate="'required'"
                    />
                    <p class="text-error" v-show="errors.has('tags')">{{ errors.first('tags') }}</p>
                  </div>

                  <!-- <div class="text-center">
									<a class="text" href="javascript:void(0);" @click="showAdvanced = !showAdvanced">Advanced <i class="fa " :class="{'fa-angle-down' : showAdvanced , 'fa-angle-up' : !showAdvanced}"></i></a>
								</div> -->

                  <template>
                    <hr />

                    <div class="form-group">
                      <label for="buttonActionInput">Button Action</label>
                      <select
                        name="buttonAction"
                        class="form-control"
                        v-model="product.buttonaction"
                      >
                        <!-- <option value="none">None</option> -->
                        <option value="url">Url</option>
                        <!-- <option value="buy">Buy</option> -->
                      </select>
                    </div>

                    <div
                      class="form-group"
                      v-if="product.buttonaction == 'url' || product.buttonaction == 'buy'"
                    >
                      <label for="buttonNameInput">Button Name</label>
                      <p>Location</p>
                    </div>

                    <div
                      class="form-group"
                      v-if="product.buttonaction == 'url'"
                      :class="{ 'has-error': errors.has('buttonUrlInput') }"
                    >
                      <label for="buttonUrlInput">Button Url *</label>
                      <input
                        type="text"
                        class="form-control"
                        id="buttonUrlInput"
                        name="buttonUrlInput"
                        aria-describedby="Button Url"
                        data-vv-as="Button Url"
                        placeholder="Button Url"
                        v-model="product.buttonurl"
                        v-validate="'required'"
                      />
                      <p class="text-error" v-show="errors.has('buttonUrlInput')">
                        {{ errors.first('buttonUrlInput') }}
                      </p>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </template>
          <!-- <template v-else>
						<product-stock v-model="product" @close="close()" @saveStock="saveStock"></product-stock>
					</template> -->
          <div class="modal-footer" v-if="currentView == 'product'">
            <button type="button" class="btn btn-primary" @click="saveProduct">Next</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectCategory from './SelectCategory'
import uploadfile from '@/components/elements/uploadfile'
import api from '@/api'
import VueTagsInput from '@johmun/vue-tags-input'
import UploadMultipleFile from '@/components/elements/UploadMultipleFile'
import ProductStock from './ProductStock'

export default {
  props: ['category', 'selectCategory'],
  data: function() {
    return {
      currentView: 'product',
      productImages: [],
      product: {
        photourl: null,
        name: null,
        description: null,
        price: 0,
        discountprice: 0,
        currency: 'THB',
        categoryid: null,
        subcategoryid: 0,
        keyword: '',

        buttonaction: 'url',
        buttonname: 'Location',
        buttonurl: ''
      },
      tag: '',
      currentCategory: null,
      showAdvanced: false
    }
  },
  computed: {
    currencySign: function() {
      if (this.product && this.product.currency) {
        switch (this.product.currency.toUpperCase()) {
          case 'THB':
            return '฿'
          case 'MMK':
            return 'K'

          default:
            return '$'
        }
      }
      return '$'
    },
    pageid: function() {
      return this.$store.state.selectedBot.pageid
    },

    tags: {
      get() {
        let vm = this
        if (vm.product.keyword != '') {
          var tags = vm.product.keyword.split(',')
          var result = []
          $.each(tags, function(index, val) {
            result.push({ text: val })
          })
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        $.each(value, function(index, val) {
          result.push(val.text)
        })
        vm.product.keyword = result.join()
      }
    }
  },
  mounted: function() {
    this.$refs.name.focus()

    if (Number.isInteger(this.selectCategory)) {
      this.currentCategory = this.selectCategory
    }
  },
  components: {
    SelectCategory: SelectCategory,
    uploadfile: uploadfile,
    VueTagsInput,
    UploadMultipleFile,
    ProductStock
  },
  methods: {
    onChangeCategory: function(payload) {
      this.currentCategory = payload
      this.product.categoryid = this.currentCategory
    },
    saveProduct: function() {
      let vm = this
      let product = vm.product

      vm.$validator.validate().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }

        product.pageid = vm.pageid
        product.categoryid = vm.currentCategory
        product.photourl = vm.productImages.join(';;')
        vm.$store.dispatch('loading')
        api.saveProduct(product, function(error, response) {
          if (error) {
            console.error(error)
            return
          }
          product.id = response.productid

          vm.productImages = []
          vm.product.categoryid = vm.currentCategory.id

          // let productstock = {
          // 	option: 'M',
          // 	productid: product.id,
          // 	quantity: 1
          // }
          // api.saveProductStock(productstock,function(error, response){
          // 	if (error) {
          // 		console.error(error)
          // 	}

          // 	productstock.id = response.productstockid

          // 	let stocks = []
          // 	stocks.push([productstock.id,productstock.option,productstock.quantity])

          // 	vm.product.productstock = stocks
          // 	vm.$nextTick(function() {

          // 		vm.currentView = 'stock'
          // 		vm.$store.dispatch('loading')
          // 	})
          // })

          vm.$emit('onAddProduct', vm.product)
          $('#modal_add_product').modal('hide')
          vm.product = {
            photourl: null,
            name: null,
            description: null,
            price: 0,
            discountprice: 0,
            currency: 'THB',
            categoryid: null,
            subcategoryid: 0,
            keyword: '',

            buttonaction: 'url',
            buttonname: 'Location',
            buttonurl: ''
          }
          vm.currentCategory = vm.selectCategory

          vm.$store.dispatch('loading')
        })
      })
    },
    saveStock: function() {
      let vm = this
      this.$emit('onAddProduct', this.product)
      $('#modal_add_product').modal('hide')
      this.product = {
        photourl: null,
        name: null,
        description: null,
        price: 0,
        discountprice: 0,
        currency: 'THB',
        categoryid: null,
        subcategoryid: 0,
        keyword: '',

        buttonaction: 'none',
        buttonname: '',
        buttonurl: ''
      }
      this.currentCategory = vm.selectCategory
      this.productImages = []
      vm.currentView = 'product'
    },
    checkTag: function(obj) {
      // if (obj.tag.text.includes(',')) alert('Letter "," is forbidden');
      // else
      obj.addTag()
    },
    close: function() {
      this.$emit('onAddProduct', this.product)
      $('#modal_add_product').modal('hide')
      // this.$store.dispatch('loading')
    }
  },
  watch: {
    selectCategory: function(newVal, oldVal) {
      this.currentCategory = newVal
    },
    'product.price': function(newVal, oldVal) {
      this.product.discountprice = newVal
    }
  }
}
</script>

<style scroped></style>



// WEBPACK FOOTER //
// src/components/view/template/event/ModalAddProduct.vue